export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fChc4AMP6lbBP.bd5406fe.woff2";